module.exports = __webpack_public_path__ + "static/media/Qr_Code.ab77a8fa.gif";